module.exports = __webpack_public_path__ + "img/img_1_intro.859bd242.png";